import moment from 'moment';
import { DEFAULT_DATE_FORMAT } from 'src/tabs/constants/Common.constants';

export const getWeekDays = (weekStartDate) => {
  const startDate = new Date(weekStartDate);
  const weekDays = [moment(weekStartDate).format(DEFAULT_DATE_FORMAT)];
  for (let index = 0; index <= 5; index++) {
    startDate.setDate(startDate.getDate() + 1);
    weekDays.push(moment(startDate).format(DEFAULT_DATE_FORMAT));
  }

  return weekDays;
};
